import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _find from 'lodash/find';

// Styles
import './FontFamilyField.less';

export default function FontFamilyField({
  availableFonts,
  element,
  input: { onChange },
  showNotesFonts,
}) {
  let recommendedFonts;
  let otherFonts;
  const { mapped: mappedFonts } = availableFonts;
  if (mappedFonts && mappedFonts.length > 0) {
    recommendedFonts = mappedFonts.filter(font => font.recommended);
    otherFonts = mappedFonts.filter(font => !font.recommended);
  }
  const { font: elementFont } = element;
  const isFontSelected = font =>
    elementFont.id === font.id || _find(font.variations, { id: elementFont.id });
  return (
    <div
      className={`font-family-selection ${showNotesFonts ? 'font-family-selection--is-short' : ''}`}
    >
      {showNotesFonts ? (
        <div className="font-family-other">
          <h6>Font for all cards:</h6>
          <ul>
            {mappedFonts &&
              mappedFonts.length > 0 &&
              mappedFonts.map(font => (
                <li
                  key={`${font.class}-${font.id}`}
                  className={`${isFontSelected(font) ? 'recommended__active' : ''}`}
                >
                  {isFontSelected(font) && <i className="zolaicon zolaicon-checkmark" />}
                  <span onClick={() => onChange(font)} style={{ fontFamily: `'${font.name}'` }}>
                    {font.name}
                  </span>
                </li>
              ))}
          </ul>
        </div>
      ) : (
        <Fragment>
          <div className="font-family-recommended">
            <h6>recommended:</h6>
            <ul>
              {recommendedFonts &&
                recommendedFonts.length > 0 &&
                recommendedFonts.map(font => (
                  <li
                    key={`${font.class}-${font.id}`}
                    className={`${isFontSelected(font) ? 'recommended__active' : ''}`}
                  >
                    {isFontSelected(font) && <i className="zolaicon zolaicon-checkmark" />}
                    <span onClick={() => onChange(font)} style={{ fontFamily: `'${font.name}'` }}>
                      {font.name}
                    </span>
                  </li>
                ))}
            </ul>
          </div>
          <div className="font-family-other">
            <h6>other:</h6>
            <ul>
              {otherFonts &&
                otherFonts.length > 0 &&
                otherFonts.map(font => (
                  <li
                    key={`${font.class}-${font.id}`}
                    className={`${isFontSelected(font) ? 'recommended__active' : ''}`}
                  >
                    {isFontSelected(font) && <i className="zolaicon zolaicon-checkmark" />}
                    <span onClick={() => onChange(font)} style={{ fontFamily: `'${font.name}'` }}>
                      {font.name}
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        </Fragment>
      )}
    </div>
  );
}

FontFamilyField.propTypes = {
  availableFonts: PropTypes.shape({
    mapped: PropTypes.arrayOf(PropTypes.shape({})),
    raw: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  element: PropTypes.shape({}),
  input: PropTypes.shape({}),
};



// WEBPACK FOOTER //
// ./src/cards/components/Customization/ElementStyleEditor/FontFamilyField/FontFamilyField.jsx